import {
  IAuthenticationService,
  ICredentials,
  ILoginRequest,
  ILogoutRequest,
} from '../../models/Auth';
import { IRequestConfig, MethodsTypes } from 'models/Axios';
import axios from 'axios';
import qs from 'qs';
import keycloak from 'utils/keycloak';
import UserService from 'services/user.service';

export default class authServices implements IAuthenticationService {
  client_id = `${process.env.REACT_APP_CLIENT_ID}`;

  client_secret = `${process.env.REACT_APP_CLIENT_SECRET}`;

  auth_url = `${process.env.REACT_APP_API_AUTH_URL}`;

  /**
   * Method to login user and return credentials
   * @param username client username
   * @param password client password
   */
  login(username: string, password: string) {
    const configs: IRequestConfig<ILoginRequest> = {
      method: MethodsTypes.post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      timeout: 8000,
      url: `${this.auth_url}/token`,
      data: qs.stringify({
        client_id: this.client_id,
        client_secret: this.client_secret,
        username,
        password,
        grant_type: 'password',
      }),
    };

    return new Promise((resolve, reject) => {
      axios(configs)
        .then((response) => {
          resolve(this.save(response.data));
        })
        .catch((err) => reject(err.response));
    });
  }

  /**
   * Method to revoke user credentials from LocalStorage and expire access_token (if have one)
   */
  logout() {
    const configs: IRequestConfig<ILogoutRequest> = {
      method: MethodsTypes.post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      url: `${this.auth_url}/logout`,
      data: qs.stringify({
        client_id: this.client_id,
        client_secret: this.client_secret,
        refresh_token: `${this.credentials()?.refresh_token}`,
      }),
    };

    if (this.credentials()?.refresh_token) {
      return new Promise((resolve, reject) => {
        axios(configs)
          .then((response) => {
            localStorage.removeItem('credentials');
            window.location.href = '/';
            resolve(response);
          })
          .catch((err) => reject(err));
      });
    }

    window.location.href = '/';
    return;
  }

  refreshToken() {
    const configs: IRequestConfig<ILogoutRequest> = {
      method: MethodsTypes.post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      url: `${this.auth_url}/token`,
      data: qs.stringify({
        client_id: this.client_id,
        refresh_token: `${this.credentials()?.refresh_token}`,
        grant_type: 'refresh_token',
      }),
    };

    return new Promise((resolve, reject) => {
      axios(configs)
        .then((response) => {
          response.data.pipefy_token = this.credentials()?.pipefy_token;
          resolve(this.save(response.data));
        })
        .catch((err) => {
          this.cleanup();
          document.location.href = '/';
          reject(err);
        });
    });
  }

  /**
   * Function to get credentials from LocalStorage
   */
  credentials(): ICredentials | undefined {
    const credentials = localStorage.getItem('credentials') || undefined;

    if (!credentials) return undefined;

    return JSON.parse(credentials);
  }

  /**
   * Function to save credentials to LocalStorage
   */
  save(entity: ICredentials) {
    localStorage.setItem('credentials', JSON.stringify(entity));
  }

  /**
   * Function to remove credentials from LocalStorage
   */
  cleanup() {
    localStorage.removeItem('credentials');
  }

  async checkSSO(): Promise<boolean> {
    return await keycloak
      .init({
        onLoad: 'check-sso',
        checkLoginIframe: false,
      })
      .then((result: any) => {
        if (result && keycloak.token) {
          localStorage.setItem(
            'credentials',
            JSON.stringify({
              access_token: keycloak.token,
              refresh_token: keycloak.refreshToken,
              pipefy_token: this.credentials()?.pipefy_token,
            })
          );
          new UserService().updateLastLogin();
        } else keycloak.login();

        return Promise.resolve(true);
      })
      .catch((error: any) => Promise.resolve(false));
  }
}
